/* IntelApps — Process Section */
import React from 'react';
import { useI18n } from '../i18n.js';

export default function ProcessSection() {
  const { t } = useI18n();

  const phases = [
    { key: 'discovery', num: '01' },
    { key: 'planning', num: '02' },
    { key: 'execution', num: '03' },
    { key: 'launch', num: '04' },
  ];

  return (
    <section className="section" id="process" style={{ paddingTop: 0, paddingBottom: 0 }}>
      <div className="container">
        <div
          className="process-inner"
          style={{
            marginBottom: 96,
            borderRadius: 28,
            padding: '64px 48px',
          }}
        >
          <div className="section-head">
            <div><span className="eyebrow">{t.process.eyebrow}</span><h2>{t.process.title}</h2></div>
            <p>
              {t.process.description}
            </p>
          </div>
          <div className="process-grid">
            {phases.map((p) => {
              const phase = t.process.phases[p.key];
              return (
                <div key={p.num} className="phase">
                  <div className="phase-head"><span className="phase-num">{t.process.phaseLabel} {p.num}</span><span className="phase-time">{phase.time}</span></div>
                  <h4>{phase.name}</h4><p>{phase.desc}</p>
                  <ul className="phase-list">
                    {phase.items.map((i) => <li key={i}>{i}</li>)}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
